export const getStoredUser = (fallback = null) => {
  let storedUser;

  try {
    storedUser = localStorage.getItem("user");
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      console.error("Unable to read user data from localStorage:", error);
    }
    return fallback;
  }

  if (storedUser === null || storedUser === undefined) {
    return fallback;
  }

  try {
    const userData = storedUser.trim();
    if (userData === "" || userData === "undefined") {
      throw new Error("Stored user data is empty or undefined");
    }

    return JSON.parse(userData);
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      console.error("Invalid user data in localStorage:", error);
    }

    try {
      localStorage.removeItem("user");
    } catch (removeError) {
      if (process.env.NODE_ENV !== "production") {
        console.error("Unable to remove invalid user data:", removeError);
      }
    }

    return fallback;
  }
};